import { Page, Card, ResourceList, ResourceItem, Text, Button, BlockStack, EmptyState } from '@shopify/polaris';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { listForms, deleteForm } from '../lib/api';

export default function Home() {
  const navigate = useNavigate();
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);

  async function refresh() {
    setLoading(true);
    try { setForms(await listForms()); } catch (e) { console.error(e); }
    setLoading(false);
  }
  useEffect(() => { refresh(); }, []);

  return (
    <Page
      title="Form Şablonları"
      primaryAction={{ content: 'Yeni Form', onAction: () => navigate('/forms/new') }}
    >
      <Card>
        {forms.length === 0 && !loading ? (
          <EmptyState
            heading="Henüz form yok"
            action={{ content: 'İlk formu oluştur', onAction: () => navigate('/forms/new') }}
            image=""
          >
            <p>Bir form şablonu oluştur, sonra ürünlere ata.</p>
          </EmptyState>
        ) : (
          <ResourceList
            loading={loading}
            items={forms}
            renderItem={(form) => (
              <ResourceItem
                id={form.id}
                onClick={() => navigate(`/forms/${encodeURIComponent(form.id)}`)}
                accessibilityLabel={form.title}
                shortcutActions={[
                  {
                    content: 'Sil',
                    destructive: true,
                    onAction: async () => {
                      if (confirm(`"${form.title}" silinsin mi?`)) {
                        await deleteForm(form.id);
                        refresh();
                      }
                    },
                  },
                ]}
              >
                <BlockStack gap="100">
                  <Text variant="bodyMd" fontWeight="semibold">{form.title}</Text>
                  <Text variant="bodySm" tone="subdued">{form.fieldCount} alan</Text>
                </BlockStack>
              </ResourceItem>
            )}
          />
        )}
      </Card>
    </Page>
  );
}
